import { VdsBadgePill } from '@volt/volt-extended-components-react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import ElementList from '@cas/components/tables/cells/element-list/ElementList';
import { EmptyCell } from '@casops/components/tables/formatters/genericFormatters';
import { AssetFileDeviceStatus } from '@casops/store/apis/registeredAssetsApi';

const getColour = (
  fileStatus: AssetFileDeviceStatus,
): 'danger' | 'healthy' | 'information' | 'neutral' | 'warning' => {
  switch (fileStatus) {
    case AssetFileDeviceStatus.Unknown:
    case AssetFileDeviceStatus.Failed:
    case AssetFileDeviceStatus.MismatchWithConfig:
    case AssetFileDeviceStatus.MissingFromDevice:
    case AssetFileDeviceStatus.MissingFromConfig:
      return 'danger';

    case AssetFileDeviceStatus.Ready:
      return 'healthy';
    case AssetFileDeviceStatus.Executing:
    case AssetFileDeviceStatus.Downloading:
      return 'warning';

    default:
      return 'neutral';
  }
};

export function FileStatusRenderer({ value }: CustomCellRendererProps): JSX.Element | null {
  const { t } = useTranslation();
  const displayValue = value == null ? EmptyCell : t(`PackageStatus.${value}`);

  return (
    <ElementList>
      {displayValue === EmptyCell ? (
        displayValue
      ) : (
        <VdsBadgePill value={displayValue} size="extra-small" statusColor={getColour(value)} />
      )}
    </ElementList>
  );
}

export default FileStatusRenderer;
